import { IsNotEmpty } from 'class-validator';

import { CompanyBatchSignEventDto } from './company-batch-sign-event.dto';

export class UkepBatchSignDto {
  @IsNotEmpty()
  events: CompanyBatchSignEventDto[];
}
